import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    loading: false,
    error: false,
    potInfo: {
      myRounds: [],
      roundsToJoin: [],
    },
    isSessionCleared: false,
  },
  reducers: {
    updateLoadingStatus: (state) => {
      state.loading = true;
    },
    updateErrStatus: (state) => {
      state.loading = false;
      state.error = true;
    },
    updateMypot: (state, actions) => {
      state.potInfo = {
        ...state.potInfo,
        myRounds: actions.payload,
      };
    },
    updateSession: (state, actions) => {
      state.isSessionCleared = actions.payload;
    },
    updateRoundToJoin: (state, actions) => {
      state.potInfo.roundsToJoin = actions.payload;
    },
    // updateJoinPotSoket: (state, action) => {
    //   const newJoinPotDetail = action.payload;

    //   const oldRoundsToJoin = JSON.parse(
    //     JSON.stringify(state.potInfo.roundsToJoin)
    //   );

    //   const oldMyRound = JSON.parse(JSON.stringify(state.potInfo.myRounds));
    //   const updatedRoundsToJoin = oldRoundsToJoin.map((round) => {
    //     const updatedPots = round.pots.map((pot) => {
    //       if (pot.id === newJoinPotDetail.id) {
    //         return {
    //           ...pot,
    //           active_picks_count: newJoinPotDetail.active_picks_count,
    //           net_pot_value: newJoinPotDetail.net_pot_value,
    //           status: newJoinPotDetail.status,
    //         };
    //       }
    //       return pot;
    //     });

    //     return {
    //       ...round,
    //       pots: updatedPots,
    //     };
    //   });

    //   state.potInfo.roundsToJoin = updatedRoundsToJoin;

    //   console.log(oldMyRound);
    //   const updatedMyRound = oldMyRound.map((round) => {
    //     const updatedPots = round.pots.map((pot) => {
    //       if (pot.id === newJoinPotDetail.id) {
    //         return {
    //           ...pot,
    //           active_picks_count: newJoinPotDetail.active_picks_count,
    //           net_pot_value: newJoinPotDetail.net_pot_value,
    //           status: newJoinPotDetail.status,
    //         };
    //       }
    //       return pot;
    //     });

    //     return {
    //       ...round,
    //       pots: updatedPots,
    //     };
    //   });

    //   state.potInfo.myRounds = updatedMyRound;
    // },

    updateJoinPotSoket: (state, action) => {
      const {
        id,
        active_picks_count,
        net_pot_value,
        status,
        lost_picks,
        pot_amount_percentage,
      } = action.payload;
      state.potInfo.roundsToJoin = state.potInfo.roundsToJoin.map((round) => ({
        ...round,
        pots: round.pots.map((pot) =>
          pot.id === id
            ? {
                ...pot,
                active_picks_count,
                lost_picks,
                net_pot_value,
                status,
                pot_amount_percentage,
              }
            : pot
        ),
      }));

      state.potInfo.myRounds = state.potInfo.myRounds.map((round) => ({
        ...round,
        pots: round.pots.map((pot) =>
          pot.id === id
            ? {
                ...pot,
                active_picks_count,
                lost_picks,
                net_pot_value,
                status,
                pot_amount_percentage,
              }
            : pot
        ),
      }));
    },
  },
});

export const {
  updateLoadingStatus,
  updateErrStatus,
  updateMypot,
  updateRoundToJoin,
  updateJoinPotSoket,
  updateSession,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
